import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70648530"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "働きたい日", -1))

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredWorkScheduleButton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: { name: 'DesiredWorkSchedules' },
    class: "button"
  }, {
    default: _withCtx(() => [
      _createVNode(FeatherIcon, { icon: "calendar" }),
      _createTextVNode(),
      _hoisted_1
    ], undefined, true),
    _: 1
  }))
}
}

})